import { useEffect } from "preact/hooks";
import { route } from "preact-router";
import type { RoutableProps } from "preact-router";
import { resendConfirmation } from "../api";
import { PendingConfirmation } from "../components/pendingConfirmation";
import { STRINGS } from "../constants/strings";
import { toErrorPath } from "../routes";

interface Props extends RoutableProps {
  linkToken?: string;
}

export function PendingScreen({ linkToken }: Props) {
  useEffect(() => {
    if (!linkToken) route(toErrorPath("invalid"), true);
  }, [linkToken]);

  if (!linkToken) return null;

  return (
    <PendingConfirmation
      token={linkToken}
      storagePrefix="review"
      resend={resendConfirmation}
      title={STRINGS.pendingTitle}
      body={STRINGS.pendingBody}
      expiry={STRINGS.pendingExpiry}
    />
  );
}
